// extracted by mini-css-extract-plugin
module.exports = {"DataContainerContainer":"DataContainer_DataContainerContainer__fBC46","DataContainerBox":"DataContainer_DataContainerBox__d_iIo"};